import svgPaths from "./svg-f4n04ujnuk";

export default function SourcityLogoWordmarkIconEmbedded() {
  return (
    <div className="relative size-full" data-name="Sourcity_Logo_Wordmark-Icon_Embedded 1">
      <svg className="block size-full" fill="none" preserveAspectRatio="xMidYMid meet" viewBox="0 0 1065 1065">
        <g clipPath="url(#clip0_12_132)" id="Sourcity_Logo_Wordmark-Icon_Embedded 1">
          <path d={svgPaths.p24a87080} fill="var(--fill-0, #7366FF)" id="Vector" />
          <path d={svgPaths.p2c2a1800} fill="var(--fill-0, #7366FF)" id="Vector_2" />
          <path d={svgPaths.p360e6200} fill="var(--fill-0, #7366FF)" id="Vector_3" />
          <path d={svgPaths.p189ed5a0} fill="var(--fill-0, #7366FF)" id="Vector_4" />
          <path d={svgPaths.p1c5ee80} fill="var(--fill-0, #7366FF)" id="Vector_5" />
        </g>
        <defs>
          <clipPath id="clip0_12_132">
            <rect fill="white" height="1064.28" width="1064.28" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}